import { IEksempelrapport } from "../reportSchemas/eksempelRapportSchema";

export const Eksempel_RAPPORT_INIT_DATA: IEksempelrapport = {
  generellInfo: {
    utarbeidetAv: "",
    kontrollertAv: "",
    godkjentAv: "",
    dokumentNr: "",
    revisjonsNr: "",
  },
  kapitler: [
    {
      id: "innledning",
      title: "Innledning",
      isActive: true,
      text: "1: Innledning",
      children: [
        {
          id: "formelleForhold",
          title: "Formelle forhold",
          isActive: true,
          text: "1.1: Formelle forhold",
          children: [
            {
              id: "avgrensning",
              title: "Avgrensning",
              isActive: true,
              text: "1.1.1: Avgrensning",
            },
          ],
        },
      ],
    },

    {
      id: "myndighetskrav",
      title: "Myndighetskrav, prosjektkrav og grensesnitt",
      isActive: true,
      text: "2: Myndighetskrav, prosjektkrav og grensesnitt",
      children: [
        {
          id: "forskrifter",
          title: "Forskrifter",
          isActive: true,
          text: "2.1: Forskrifter",
          children: [
            {
              id: "relevanteStandarder",
              title: "Relevante standarder",
              isActive: true,
              text: "2.1.1: Relevante standarder",
            },
            {
              id: "dokumentasjon",
              title: "Dokumentasjon",
              isActive: true,
              text: "2.1.2: Dokumentasjon",
            },
          ],
        },
        {
          id: "prosjektspesifikkeKrav",
          title: "Prosjektspesifikke krav ut over forskriftskrav",
          isActive: true,
          text: "2.2: Prosjektspesifikke krav ut over forskriftskrav",
        },
      ],
    },

    {
      id: "grunnlag",
      title: "Grunnlag og forutsetninger",
      isActive: true,
      text: "3: Grunnlag og forutsetninger",
      children: [
        {
          id: "datagrunnlag",
          title: "Datagrunnlag",
          isActive: true,
          text: "3.1: Datagrunnlag",
          children: [
            {
              id: "grunnlagTegninger",
              title: "Tegninger",
              isActive: true,
              text: "3.1.1: Tegninger",
            },
            {
              id: "grunnlagBefaring",
              title: "Befaring",
              isActive: false,
              text: "3.1.2: Befaring",
            },
            {
              id: "grunnlagMalinger",
              title: "Målinger",
              isActive: false,
              text: "3.1.3: Målinger",
            },
          ],
        },
      ],
    },

    {
      id: "dokumentasjonKap",
      title: "Dokumentasjon",
      isActive: true,
      text: "4: Dokumentasjon",
      children: [
        {
          id: "vedlegg",
          title: "Vedlegg",
          isActive: true,
          text: "4.1: Vedlegg",
          children: [
            {
              id: "vedleggTegninger",
              title: "Tegninger som vedlegg",
              isActive: true,
              text: "4.1.1: Tegninger som vedlegg",
            },
            {
              id: "vedleggFoto",
              title: "Fotodokumentasjon",
              isActive: false,
              text: "4.1.2: Fotodokumentasjon",
            },
          ],
        },
      ],
    },

    {
      id: "kvalitetssikring",
      title: "Kvalitetssikring",
      isActive: true,
      text: "6: Kvalitetssikring",
      children: [
        {
          id: "sporbarhet",
          title: "Sporbarhet og revisjon",
          isActive: false,
          text: "6.1: Sporbarhet og revisjon",
        },
        {
          id: "kontrollplan",
          title: "Kontrollplan",
          isActive: true,
          text: "6.2: Kontrollplan",
        },
      ],
    },
  ],
};
